import {WinPresentationController} from "../../WinPresentationController";
import {BigWinView} from "./BigWinView";
import {TheRave} from "../../../TheRave";
import {TimelineLite, TweenLite} from "gsap";
import {TheRaveGameConfig} from "../../../TheRaveGameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class BigWinController extends WinPresentationController {

    private _view: BigWinView;
    private _levelTimeline: TimelineLite | null;

    constructor() {
        super("BigWinController", true);
        this._view = new BigWinView();
    }

    protected hasWin(): boolean {
        return TheRave.model.parsedGameData.currentWinRatioConfig!.bigWinLevel > -1 && !TheRave.model.parsedGameData.brokeTheBank;
    }

    protected async createWinAnimation(): Promise<any> {
        //await Promise.resolve();
        await new Promise<void>(resolve => {
            this.playBigWinLevel(0, resolve);
        });
    }

    private playBigWinLevel(level: number, resolve: () => void): void {
        const data = TheRave.model.parsedGameData;
        if (level > TheRave.model.parsedGameData.currentWinRatioConfig!.bigWinLevel) {
            this._levelTimeline = null;
            this.playEnding(resolve);
        } else {
            const isEndLevel = level === data.currentWinRatioConfig!.bigWinLevel;
            const currentRatio = TheRaveGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === level)!;
            const nextRatio = TheRaveGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === level + 1)!;
            const from:number = level === 0 ? 0 : data.playedBetValue * currentRatio.ratio;
            let to:number = isEndLevel ? data.singleWin : data.playedBetValue * TheRaveGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === (level + 1))!.ratio;
            const tooSmallEndLevel:boolean = isEndLevel && this.isLevelWinTooSmall(level, from, to);
            const nextLevelTooSmall:boolean = (!isEndLevel && this.isNextLevelWinTooSmall(data.playedBetValue * nextRatio.ratio, data.singleWin));

            this._flowStateController.setSkipCallback(() => this.skip!());
            const tl = new TimelineLite();

            tl.add(this.getLevelAnimation(level, nextLevelTooSmall));
            tl.add(() => this.playBigWinLevel(level + 1, resolve));
            this._levelTimeline = tl;
            if(tooSmallEndLevel) {
                this._levelTimeline.progress(1);
            } else {
                this._flowStateController.setSkipCallback(() => this.skip!());
            }
        }
    }

    private isLevelWinTooSmall(level:number, from:number, to:number):boolean {
        if(level === 0) {
            return false;
        }

        return (to - from) <= (from * 0.2);
    }

    private isNextLevelWinTooSmall(from:number, to:number):boolean {
        //debugger;
        /*
        below 20% bw 1
        [["L1","M2","M2",""],["L1","M2","M2",""],["L1","W","M2",""],["L1","W","M1",""],["M1","W","L2",""]]

        slightly above 20% bw1
        [["L1","M2","M2",""],["L1","M2","M2",""],["L1","W","M2",""],["L1","W","M1",""],["M1","W","L1",""]]
         */
        return (to - from) <= (from * 0.2);
    }

    private getLevelAnimation(level: number, smallEnd:boolean = false): TimelineLite {
        const data = TheRave.model.parsedGameData;
        const currentRatio = TheRaveGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === level)!;
        const from: number = level === 0 ? 0 : data.playedBetValue * currentRatio.ratio;
        const to: number = level === (data.currentWinRatioConfig!.bigWinLevel) || smallEnd ? data.singleWin : data.playedBetValue * TheRaveGameConfig.WIN_RATIOS.find(r => r.bigWinLevel === (level + 1))!.ratio;
        const duration = currentRatio.duration;
        const tl = new TimelineLite();
        if (level === 0) {

            tl.add([this._view.start(),TheRave.waysWon.remove()]);
        }
        tl.add([
            this._view.getLevelAnimation(level, duration, false),
            TheRave.bigWinCountUp.getCountUpAnimation(from, to, duration),
            TweenLite.to(TheRave.bigWinCountUp.scale, {duration: duration, x: 1, y: 1, ease: `power4.out`})
        ]);
        return tl;
    }

    protected skip() {
        if (this._levelTimeline && this._levelTimeline.isActive()) {
            this._levelTimeline.progress(1);
        }
    }

    private playEnding(resolve: () => void): void {
        this._flowStateController.setSkipCallback();
        TheRave.bigWinCountUp.scale.set(1);
        TheRave.bigWinCountUp.stay();
        SlotGame.keypadPlugin.setWin(TheRave.model.parsedGameData.totalWin, TheRave.model.parsedGameData.showTotalWin, TheRave.isWinBelowStake());
        resolve();
        const tl = new TimelineLite();
        tl.add(() => {
            this._view.getEndingAnimation();
        });
        tl.add(()=> {
            TheRave.bigWinCountUp.remove();
            TheRave.waysWon.remove();
        });
    }
}